import { Flex, View, Text } from '@smarterservices/smarter-ui';
import useAppStore from '../../stores/app';
import useSessionStore from '../../stores/session';
import useLayoutStore from '../../stores/layout';
import SessionCard from '../SessionCard';
import { useEffect } from 'react';

const SessionGrid = () => {
  const { calculateLayoutSizing } = useLayoutStore();
  const { testing, testingCount } = useSessionStore();
  const sessionDimensions = useLayoutStore((state) => state.sessionDimensions);

  useEffect(() => {
    // When the testing object changes, we need to trigger a
    calculateLayoutSizing();
  }, [testingCount]);

  return (
    <>
      {Object.keys(testing).length > 0 ? (
        <Flex
          direction="row"
          justifyItems="center"
          alignItems="center"
          margin="none"
          withVisualDebug={false}
          padding="none"
          gap="none"
          wrap="wrap"
        >
          {Object.entries(testing).map(([sessionSid, data]) => (
            <Flex.Item
              key={`session_${sessionSid}`}
              margin="none"
              padding="xxx-small"
              width={`${sessionDimensions?.width}px`}
              height={`${sessionDimensions?.height}px`}
            >
              <SessionCard
                key={`session_card_${sessionSid}`}
                sessionSid={sessionSid}
                data={data}
              />
            </Flex.Item>
          ))}
        </Flex>
      ) : (
        <>
          <View
            as="div"
            display="inline-block"
            alignItems="center"
            justifyContent="center"
            margin="x-large auto"
            width="100%"
          >
            <Text>There are currently no sessions in the room.</Text>
          </View>
        </>
      )}
    </>
  );
};

export default SessionGrid;
